import { Link, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";

const ADMIN_EMAIL = "jonnybroughton@me.com";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  async function handleLogout() {
    await signOut(auth);
    navigate("/login");
  }

  const links = [
    { to: "/", label: "Home" },
    { to: "/events", label: "Events" },
    { to: "/leagues", label: "Leagues" },
    { to: "/my-predictions", label: "Picks" },
  ];

  return (
    <nav style={{ backgroundColor: "#0A0B0F", borderBottom: "1px solid #1E2028" }} className="sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">

        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <span className="hidden md:block font-display text-3xl tracking-wider" style={{ color: "#C8FF00" }}>
            PREDICTORZ.
          </span>
          <span className="block md:hidden font-display text-2xl tracking-wider" style={{ color: "#C8FF00" }}>
            P.
          </span>
        </Link>

        {/* Nav links — scrollable on mobile */}
        <div className="flex items-center gap-3 md:gap-6 overflow-x-auto no-scrollbar mx-2">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="font-condensed text-base md:text-lg tracking-wide transition-colors flex-shrink-0"
              style={location.pathname === link.to ? { color: "#C8FF00" } : { color: "#888" }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link
            to="/profile"
            className="font-condensed text-gray-400 text-base md:text-lg tracking-wide transition-colors"
          >
            <span className="hidden md:block">Profile</span>
            <span className="block md:hidden text-xl">👤</span>
          </Link>

          {currentUser?.email === ADMIN_EMAIL && (
            <Link
              to="/admin"
              className="font-condensed text-sm tracking-wide px-3 py-1.5 rounded-lg transition-all"
              style={{
                backgroundColor: location.pathname === "/admin" ? "#FF5C00" : "transparent",
                color: location.pathname === "/admin" ? "#fff" : "#FF5C00",
                border: "1px solid #FF5C00",
              }}
            >
              Admin
            </Link>
          )}

          <button
            onClick={handleLogout}
            className="font-condensed tracking-wide text-sm px-3 py-1.5 rounded-lg transition hidden md:block"
            style={{ border: "1px solid #1E2028", color: "#888" }}
          >
            Log out
          </button>
        </div>
      </div>
    </nav>
  );
}